// Environment detection and configuration utility
// frontend/src/config.js

const getEnvironmentConfig = () => {
  // Detect environment based on hostname and environment variables
  const hostname = window.location.hostname;
  const isDevelopment =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    process.env.NODE_ENV === 'development'; //

  const isRender =
    hostname.includes('.onrender.com') ||
    process.env.REACT_APP_ENVIRONMENT === 'render'; //

  const isProduction =
    process.env.NODE_ENV === 'production' &&
    !isDevelopment; //

  // Test mode - can be controlled via environment variable
  const testMode = process.env.REACT_APP_TEST_MODE === 'true'; //

  // API Base URL auto-detection
  let apiBaseUrl;
  if (isDevelopment) {
    apiBaseUrl = 'http://localhost:5000/api'; //
  } else if (isRender) {
    // Use your actual Render API URL here
    apiBaseUrl = 'https://karbonkit-api.onrender.com/api'; //
  } else {
    // Fallback for other production environments
    apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://karbonkit-api.onrender.com/api'; //
  }

  // Asset Base URL auto-detection
  let assetBaseUrl;
  if (process.env.REACT_APP_ASSET_BASE_URL) {
    // Highest priority: explicit environment variable for assets
    assetBaseUrl = process.env.REACT_APP_ASSET_BASE_URL;
  } else if (isDevelopment) {
    assetBaseUrl = 'http://localhost:5000'; // Corresponds to apiBaseUrl host
  } else if (isRender) {
    assetBaseUrl = 'https://karbonkit-api.onrender.com'; // Corresponds to apiBaseUrl host
  } else {
    // For other production environments, attempt to derive from the determined apiBaseUrl
    // This assumes apiBaseUrl ends with '/api'
    if (apiBaseUrl && apiBaseUrl.endsWith('/api')) {
      assetBaseUrl = apiBaseUrl.substring(0, apiBaseUrl.length - '/api'.length);
    } else {
      // Fallback if apiBaseUrl is unusual (e.g., doesn't end with /api) or not set,
      // and REACT_APP_ASSET_BASE_URL was not provided.
      // Defaulting to Render host; consider a more specific error or configuration if this case is hit.
      console.warn(
        "Could not reliably derive assetBaseUrl from apiBaseUrl. " +
        "Consider setting REACT_APP_ASSET_BASE_URL explicitly in your environment. " +
        "Falling back to Render default host for assets."
      );
      assetBaseUrl = 'https://karbonkit-api.onrender.com'; // Default Render host as a last resort
    }
  }

  return {
    isDevelopment,
    isRender,
    isProduction,
    testMode,
    apiBaseUrl,
    assetBaseUrl, // Add assetBaseUrl to the returned config object
    environment: isDevelopment ? 'development' : isRender ? 'render' : 'production' //
  };
};

export default getEnvironmentConfig;

// Usage example:
// import getEnvironmentConfig from './config';
// const config = getEnvironmentConfig();
// console.log('Environment:', config.environment);
// console.log('API URL:', config.apiBaseUrl);
// console.log('Asset URL:', config.assetBaseUrl);